// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/component-spinner-button/index.sass
 ** module id = 386
 ** module chunks = 1
 **/